import BoardShowComponent from "../../components/board/BoardShowComponent";

const BoardShowPage = ({isManagePage}) => {
  return <BoardShowComponent isManagePage={isManagePage} />;
};

export default BoardShowPage;
